export const LOCAL_STORAGE_PREFERRED_CC_SORT = 'crouchcancel_sort';
export const LOCAL_STORAGE_PREFERRED_CC_FLOOR = 'crounccancel_floor';
export const LOCAL_STORAGE_PREFERRED_CC_NUMERIC_MAX = 'crounccancel_num_max';
